import { createApi } from "@reduxjs/toolkit/query/react";
import { buildFiltersUrl } from "helpers/functions";
import customFetchBase from "services/principal/customFetchBase";

export const reporteRegulacionesApi = createApi({
  reducerPath: "reporteRegulacionesApi",
  baseQuery: customFetchBase,
  tagTypes: ["Reportes Regulaciones"],
  endpoints: (builder) => ({
    makeReporte: builder.mutation({
      query: ({ filter_params, body }) => ({
        url: buildFiltersUrl("/v1/api/repo-pendientes/make/", filter_params),
        method: "POST",
        body: body,
      }),
      providesTags: (result) =>
        Array.isArray(result)
          ? [
              ...result.map(({ id }) => ({
                type: "Reporte",
                id,
              })),
              { type: "Reporte", id: "LIST" },
            ]
          : [{ type: "Reporte", id: "LIST" }],
    }),
    makeHistorial: builder.mutation({
      query: ({ filter_params, body }) => ({
        url: buildFiltersUrl("/v1/api/repo-historial/make/", filter_params),
        method: "POST",
        body: body,
      }),
      providesTags: (result) =>
        Array.isArray(result)
          ? [
              ...result.map(({ id }) => ({
                type: "Reporte Historico",
                id,
              })),
              { type: "Reporte Historico", id: "LIST" },
            ]
          : [{ type: "Reporte Historico", id: "LIST" }],
    }),
  }),
});

export const { useMakeReporteMutation, useMakeHistorialMutation } =
  reporteRegulacionesApi;
